import { useEffect } from "react";
import { singWebinarDataAsync } from "../../../store/features/EventManage/Webinars/webinarsApi";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { ModalType } from "../../../types";
import { GetSingleWebinarData } from "../../../types/eventManage/webinars";
import CustomModal from "../../ui/CustomModal";
import DateCard from "../../ui/DateCard";
import GuestCard from "../../ui/GuestCard";

type Props = {
  open: ModalType;
  handleClose: () => void;
};

export default function WebinarView({ open, handleClose }: Props) {
  const dispatch = useAppDispatch();
  const { singleWebinarData } = useAppSelector((state) => state.webinar);
  const viewData = singleWebinarData as GetSingleWebinarData;

  useEffect(() => {
    dispatch(
      singWebinarDataAsync({
        params: {
          id: open?.data?.webinarId,
        },
      })
    );
  }, [dispatch, open?.data?.webinarId]);

  return (
    <CustomModal
      disabled={false}
      open={open?.open}
      title="Webinar View"
      handleClose={handleClose}
      width={772}
    >
      <>
        <div className="h-[142px] justify-start items-start gap-3 inline-flex">
          <DateCard
            start_date={viewData?.webinarStartDate}
            title={viewData?.webinarTitle}
            end_date={viewData?.webinarEndDate}
            organized_by={viewData?.webinarOrganizedBy}
            hosted_by={viewData?.webinarHostBy}
            campaign_Address={viewData?.webinarVenueName}
          />
        </div>

        <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-2.5 mt-4">
          {viewData?.webinarGuests?.map((val) => (
            <GuestCard
              designation={val?.designation}
              image={val?.photo}
              name={val?.fullName}
              profession={val?.profession}
            />
          ))}
        </div>
      </>
    </CustomModal>
  );
}
